"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Error", {
  enumerable: true,
  get: function get() {
    return _styled.Error;
  }
});
Object.defineProperty(exports, "InnerInput", {
  enumerable: true,
  get: function get() {
    return _styled.InnerInput;
  }
});
Object.defineProperty(exports, "InputWrapper", {
  enumerable: true,
  get: function get() {
    return _styled.InputWrapper;
  }
});
Object.defineProperty(exports, "IconWrap", {
  enumerable: true,
  get: function get() {
    return _styled.IconWrap;
  }
});
exports["default"] = exports.Input = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ControlsGroup = _interopRequireDefault(require("../ControlsGroup"));

var _styled = require("./styled");

var _propTypes = _interopRequireDefault(require("prop-types"));

/* eslint-disable  react/jsx-no-bind */
var InputControl =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(InputControl, _PureComponent);

  function InputControl(_props) {
    var _this;

    (0, _classCallCheck2["default"])(this, InputControl);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(InputControl).call(this, _props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onIconPress", function (e) {
      if (!_this.state.isActive) {
        e.preventDefault();

        _this.innerInput.current.focus();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function (onFocus, e) {
      if (_this.props.onFocus) _this.props.onFocus(e);
      if (onFocus) onFocus(e);

      _this.setState({
        isActive: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBlur", function (onBlur, e) {
      if (_this.props.onBlur) _this.props.onBlur(e);
      if (onBlur) onBlur(e);

      _this.setState({
        isActive: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderInputElement", function () {
      var _this$props = _this.props,
          size = _this$props.size,
          success = _this$props.success,
          error = _this$props.error,
          disabled = _this$props.disabled,
          leftIcon = _this$props.leftIcon,
          rightIcon = _this$props.rightIcon,
          isTextarea = _this$props.isTextarea,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["size", "success", "error", "disabled", "leftIcon", "rightIcon", "isTextarea"]);
      var InputComponent = isTextarea ? _styled.InnerTextarea : _styled.InnerInput;
      return _react["default"].createElement(InputComponent, (0, _extends2["default"])({}, props, {
        size: size,
        disabled: disabled,
        success: success,
        error: error,
        onFocus: _this.handleFocus.bind(null, null),
        onBlur: _this.handleBlur.bind(null, null),
        ref: _this.innerInput,
        isTextarea: isTextarea,
        leftIcon: leftIcon,
        rightIcon: rightIcon
      }));
    });
    var innerRef = _this.props.innerRef;
    _this.state = {
      isActive: false
    };
    _this.innerInput = innerRef || _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(InputControl, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          active = _this$props2.active,
          size = _this$props2.size,
          success = _this$props2.success,
          error = _this$props2.error,
          disabled = _this$props2.disabled,
          neighboringInGroup = _this$props2.neighboringInGroup,
          children = _this$props2.children,
          leftIcon = _this$props2.leftIcon,
          rightIcon = _this$props2.rightIcon,
          handleLeftIconPress = _this$props2.handleLeftIconPress,
          handleRightIconPress = _this$props2.handleRightIconPress,
          isTextarea = _this$props2.isTextarea,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["active", "size", "success", "error", "disabled", "neighboringInGroup", "children", "leftIcon", "rightIcon", "handleLeftIconPress", "handleRightIconPress", "isTextarea"]);

      var leftIconsArray = _react["default"].Children.toArray(leftIcon);

      var rightIconsArray = _react["default"].Children.toArray(rightIcon);

      return _react["default"].createElement(_styled.InputWrapper, {
        active: active || this.state.isActive,
        size: size,
        disabled: disabled,
        success: success,
        error: error,
        neighboringInGroup: neighboringInGroup,
        isTextarea: isTextarea
      }, leftIcon ? _react["default"].createElement(_styled.IconWrap, {
        onMouseDown: handleLeftIconPress ? function (e) {
          return handleLeftIconPress(_this2.innerInput, e);
        } : this.onIconPress,
        size: size,
        isGroup: leftIconsArray.length > 1,
        left: true
      }, leftIconsArray) : null, children ? _react["default"].createElement(_ControlsGroup["default"], {
        className: "combined-inputs-group"
      }, _react["default"].Children.map(children, function (child) {
        return _react["default"].cloneElement(child, (0, _objectSpread2["default"])({}, props, {
          size: size,
          name: child.props.name,
          hasInnerGroup: true,
          onFocus: _this2.handleFocus.bind(null, child.props.onFocus),
          onBlur: _this2.handleBlur.bind(null, child.props.onBlur)
        }));
      })) : this.renderInputElement(), rightIcon ? _react["default"].createElement(_styled.IconWrap, {
        onMouseDown: handleRightIconPress ? function (e) {
          return handleRightIconPress(_this2.innerInput, e);
        } : this.onIconPress,
        size: size,
        isGroup: rightIconsArray.length > 1,
        right: true
      }, rightIconsArray) : null, _react["default"].createElement(_styled.StatusIndicator, {
        error: !active && error,
        success: success,
        active: active || this.state.isActive
      }), error && !active && _react["default"].createElement(_styled.Error, null, error));
    }
  }]);
  return InputControl;
}(_react.PureComponent);

exports.Input = InputControl;
(0, _defineProperty2["default"])(InputControl, "defaultProps", {
  name: 'input',
  size: 'normal',
  innerRef: null
});
(0, _defineProperty2["default"])(InputControl, "propTypes", {
  name: _propTypes["default"].string,
  type: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  success: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string,
  neighboringInGroup: _propTypes["default"].oneOf(["left", "right", "both"]),
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  leftIcon: function leftIcon() {
    return (typeof React$Element === "function" ? _propTypes["default"].instanceOf(React$Element) : _propTypes["default"].any).apply(this, arguments);
  },
  rightIcon: function rightIcon() {
    return (typeof React$Element === "function" ? _propTypes["default"].instanceOf(React$Element) : _propTypes["default"].any).apply(this, arguments);
  },
  handleLeftIconPress: _propTypes["default"].func,
  handleRightIconPress: _propTypes["default"].func,
  innerRef: _propTypes["default"].func,
  children: _propTypes["default"].arrayOf(function () {
    return (typeof React$Element === "function" ? _propTypes["default"].instanceOf(React$Element).isRequired : _propTypes["default"].any.isRequired).apply(this, arguments);
  }),
  isTextarea: _propTypes["default"].bool
});

var RFInput = function RFInput(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["input", "meta"]);
  return _react["default"].createElement(InputControl, (0, _extends2["default"])({}, input, meta, props, {
    error: meta.touched && meta.error,
    success: meta.touched && meta.valid
  }));
};

var _default = RFInput;
exports["default"] = _default;